export const getDeploymentFromHostname = (hostname: string) => {
	const re = /^([a-z]+)\.staging\.performyard\.com/;
	const match = hostname.match(re);
	if (match) {
		return match[1];
	} else if (hostname === "staging.talent.performyard.com") {
		return "staging";
	} else if (hostname === "localhost") {
		return "localhost";
	} else if (hostname === "demo.talent.performyard.com") {
		return "demo";
	} else if (hostname === "sandbox.talent.performyard.com") {
		return "sandbox";
	} else if (hostname === "preview.talent.performyard.com") {
		return "preview";
	}

	return "production";
};

export const getEnvironmentFromHostname = (hostname: string) => {
	const deployment = getDeploymentFromHostname(hostname);

	switch (deployment) {
		case "han":
		case "yoda":
		case "luke":
		case "leia":
		case "rogu":
		case "staging":
			return "staging";
		case "preview":
			return "preview";
		case "demo":
		case "sandbox":
			return "sandbox";
		case "production":
			return "production";
		case "localhost":
			return "localhost";
	}

	return "production";
};

export const getDeployment = () => {
	const { hostname } = window.location;
	return getDeploymentFromHostname(hostname);
};

export const getEnvironment = () => {
	const { hostname } = window.location;

	return getEnvironmentFromHostname(hostname);
};
